import React from "react";
import { Controller, useForm } from "react-hook-form";
import { RequirementRejectReason } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import CheckBox from "../../../../components/check-box";
import { AppPermissions, useHasPermission } from "../../../../core";

const CreateForm: React.FunctionComponent<{
  onSubmit: (data: RequirementRejectReason) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  isDeleteModalOpen?: boolean;
  data?: RequirementRejectReason;
  error?: string;
  onDelete: (id?: string) => void;
  setDeleteModalStatus: (status: boolean) => void;
}> = (props) => {
  const canDeleteRequirementReason = useHasPermission(
    AppPermissions.DeleteRequirementReason
  );
  const canCreateRequirementReason = useHasPermission(
    AppPermissions.CreateRequirementReason
  );
  const canUpdateRequirementReason = useHasPermission(
    AppPermissions.UpdateRequirementReason
  );

  const { control, handleSubmit, errors } = useForm<RequirementRejectReason>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });


  const renderDeleteConfirm = () => {
    return props?.isDeleteModalOpen ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>
                        You are about to delete the Reason{" "}
                        {props.data?.reason}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={() => props.setDeleteModalStatus(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => props.onDelete(props.data?._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };  

  const renderReasonTextBox = () => {
    return (
      <div className="col-lg-12 col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Reason<span className="text-danger">*</span></label>
          <Controller
            control={control}
            rules={{ required: "Reason is required" }}
            name="reason"
            defaultValue={props.data?.reason}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Reason"
                name={name}
                value={value}
                onChange={onChange}
                id="reason"
              />
            )}
          />
          <ErrorMessage>{errors.reason?.message}</ErrorMessage>
        </div>
      </div>
    );
  };
  // const renderArabicTextBox = () => {
  //   return (
  //     <div className="col-lg-12 col-12">
  //       <div className="form-group font-weight-semibold mb-3">
  //         <label className="font-sm text-uppercase">Name in Arabic</label>
  //         <Controller
  //           control={control}
  //           rules={{ required: "Arabic name is required" }}
  //           name="translations.reason.ar"
  //           defaultValue={props.data?.translations?.reason?.ar}
  //           render={({ onChange, value, name }) => (
  //             <input
  //               type="text"
  //               className="form-control rounded-sm font-weight-semibold"
  //               id="arabicName"
  //               placeholder="Arabic Name"
  //               name={name}
  //               value={value}
  //               onChange={onChange}
  //             />
  //           )}
  //         />
  //         <ErrorMessage>
  //           {errors?.translations?.reason?.ar?.message}
  //         </ErrorMessage>
  //       </div>
  //     </div>
  //   );
  // }; 

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          {props.data?._id && canDeleteRequirementReason && (
            <button
              type="button"
              className="btn btn-outline-gray py-2 font-weight-semibold font-normal px-4 mr-1"
              onClick={() => props.setDeleteModalStatus(true)}
            >
              <i className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"></i>
            </button>
          )}
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          {canCreateRequirementReason && !props.data?._id && (
            <button
              type="submit"
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
              disabled={props.isSubmitting}
            >
              Create
            </button>
          )}
          {canUpdateRequirementReason && props.data?._id && (
            <button
              type="submit"
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
              disabled={props.isSubmitting}
            >
              Update
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          {props.data && props.data._id ? "Update " : "Create "} Reason
        </h4>
        <div className="row gutter-10">
          {renderReasonTextBox()}          
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
          {renderDeleteConfirm()}
        </div>
      </div>
    </form>
  );
};

export default CreateForm;
